import React from 'react';

function AboutTeamSection() {
  return (
    <section className="about-team-section">
      <div className="container about-team-container">
        {/* Left Content Column */}
        <div className="about-team-left">
          <h2 className="about-team-title">
            About Experts Communication
          </h2>
          <p className="about-team-description">
            Experts Communication is a leading IT &amp; BPO company helping startups and global enterprises build and implement digital transformation solutions tailored to their demand and needs.
          </p>
          <div className="about-team-features-grid">
            <ul className="about-team-feature-list">
              <li>Tech Integrated Solutions</li>
              <li>Disruptive Innovation</li>
            </ul>
            <ul className="about-team-feature-list">
              <li>Client Focused Approach</li>
              <li>Digital Transformation Partner</li>
            </ul>
          </div>
        </div>

        {/* Right Image Column */}
        <div className="about-team-right">
          <img 
            src="/assets/images/team-moc1.png" 
            alt="About Experts Communication World Map" 
            className="about-team-img"
          />
        </div>
      </div>
    </section>
  );
}

export default AboutTeamSection;
